"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOM_HEADERS = void 0;
exports.CUSTOM_HEADERS = {
    clientDateTime: 'client-date-time',
};
